import { Accordion, AccordionDetails, AccordionSummary, Box, Grid, IconButton, Paper, Typography } from '@mui/material';
import NewGeneralSetting from './newGeneralSetting';
import AddIcon from '@mui/icons-material/Add';
import CloseIcon from '@mui/icons-material/Close';
import { useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
const NewGeneralSettingAC = ({ fyData = '', top = 0, left = 0, newFyId = {}, setHideFloatBtn = () => {} }) => {
  const [expanded, setExpanded] = useState(fyData);

  const closeBookFYState = useSelector((state) => state?.userPrefrenceandReducer?.financialYear);

  useEffect(() => {
    if (newFyId?.financialyearid) {
      setExpanded(true);
    } else {
      setExpanded(false);
    }
  }, []);

  useEffect(() => {
    if (expanded === true) {
      setHideFloatBtn(true);
    } else {
      setHideFloatBtn(false);
    }
  }, [expanded]);

  return (
    <Grid container>
      <Accordion
        expanded={expanded}
        onChange={() => setExpanded(!expanded)}
        sx={{
          width: '100%',
        }}
      >
        <AccordionSummary
          aria-controls="panel1bh-content"
          id="panel1bh-header"
          sx={{
            width: '100%',
            display: 'flex',
            flexDirection: 'row', // Keep row direction
            alignItems: 'center',
          }}
        >
          <Typography
            sx={{
              fontWeight: '600',
              fontSize: '18px',
            }}
          >
            Voucher Number Settings ({newFyId?.startyear || closeBookFYState?.startyear}-{newFyId?.endyear || closeBookFYState?.endyear})
          </Typography>
          <IconButton
            onClick={() => setExpanded(!expanded)}
            sx={{
              color: 'blue', // Customize color
              marginLeft: '8px', // Space between text and icon
              padding: '0px',
            }}
          >
            {expanded ? <CloseIcon /> : <AddIcon />}
          </IconButton>
        </AccordionSummary>
        <AccordionDetails sx={{ height: '100%', width: ' 100%' }}>
          <NewGeneralSetting fyData={newFyId} expanded={expanded} />
        </AccordionDetails>
      </Accordion>
    </Grid>
  );
};

export default NewGeneralSettingAC;
